export default "__VITE_ASSET__32ID$cNn__"